import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import { FHEContainer } from 'data/components';
import { Toastr, tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { SvgHome, SvgCraftsman, SvgUser } from 'data/common/iconsvg';
import { TableDetails, TableHome, TableCraftsman, TableUsersManager } from './Table';
import FormManagement from './Form/FormManagement';
import { getManagementDetails, updateManagementDetails } from '../../data/Managements/actions';

class ManagementDetail extends PureComponent {
    static propTypes = {
        getManagementDetails: PropTypes.func.isRequired,
        updateManagementDetails: PropTypes.func.isRequired,
        managementId: PropTypes.string.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            error: null,
        };
    }

    componentDidMount() {
        this.getManagementDetails();
    }

    getManagementDetails = () => {
        const { getManagementDetails, managementId } = this.props;
        this.setState({ loading: true, error: null });
        getManagementDetails(managementId)
            .then(() => {
                this.setState({
                    loading: false,
                    error: null,
                });
            })
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
                this.setState({
                    error: message,
                    loading: false,
                });
            });
    };
    updateManagementDetails = data => {
        const { managementId, updateManagementDetails } = this.props;
        return updateManagementDetails(managementId, data);
    };

    renderChildren = () => {
        const { managementId } = this.props;
        return (
            <FormManagement
                type="update"
                sendDataFunc={this.updateManagementDetails}
                renderOtherChildren={() => (
                    <Fragment>
                        <TableDetails
                            title={Translator.translate('general.Homes')}
                            icon={SvgHome}
                            table={TableHome}
                            managementId={parseInt(managementId)}
                        />
                        <TableDetails
                            title={Translator.translate('general.Craftsmen')}
                            icon={SvgCraftsman}
                            table={TableCraftsman}
                            managementId={parseInt(managementId)}
                        />
                        <TableDetails
                            title={Translator.translate('general.UsersManager')}
                            icon={SvgUser}
                            table={TableUsersManager}
                            managementId={parseInt(managementId)}
                        />
                    </Fragment>
                )}
            />
        );
    };

    render() {
        const { loading, error } = this.state;
        return <FHEContainer withBackIcon loading={loading} error={error} onClickFunc={this.getManagementDetails} onRender={this.renderChildren} />;
    }
}

function mapStateToProps(state, props) {
    return {
        profile: state.data.user,
        managementId: props.match.params.managementId,
    };
}

const styles = () => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20,
    },
});

export default withRouter(
    renderEnvComponent(
        'scenes/Management/details',
        connect(
            mapStateToProps,
            (dispatch, ownProps) =>
                bindActionCreators(
                    tools.mergePropsToAction(ownProps.history.environment, { getManagementDetails, updateManagementDetails }),
                    dispatch,
                ),
        )(withStyles(styles, { withTheme: true })(ManagementDetail)),
    ),
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Management/details.js